export default __webpack_public_path__ + "static/media/chevron-down.4485a8ac.svg";